var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.mobileLogin)?_c('mobile-header'):_vm._e(),(_vm.isRouterAlive)?_c('router-view',{staticClass:"body",class:{ 'pt-40': !_vm.mobileLogin }}):_vm._e(),(!_vm.footerShow)?_c('mobile-footer'):_vm._e(),(!_vm.mobileLogin)?_c('mobile-consulting-Services'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }